// Copyright 2020-2021 the .NET Foundation
// Licensed under the MIT License
// Toplevel documentation found at @/docs/engine/research-app-messages-index.md
import * as classicPywwt from './classic_pywwt';
import * as layers from './layers';
import * as selections from './selections';
import * as settings from './settings';
export { classicPywwt, layers, selections, settings, };
/** Type guard function for ViewStateMessage. */
export function isViewStateMessage(o) {
    return typeof o.type === "string" &&
        o.type == "wwt_view_state" &&
        typeof o.sessionId === "string" &&
        typeof o.raRad === "number" &&
        typeof o.decRad === "number" &&
        typeof o.fovDeg === "number" &&
        typeof o.engineClockISOT === "string" &&
        typeof o.systemClockISOT === "string" &&
        typeof o.engineClockRateFactor === "number";
}
/** Type guard function for [[PingPongMessage]]. */
export function isPingPongMessage(o) {
    return typeof o.type === "string" &&
        o.type == "wwt_ping_pong" &&
        typeof o.threadId === "string" &&
        (o.sessionId === undefined || typeof o.sessionId === "string");
}
